import { render, staticRenderFns } from "./LmSlider.vue?vue&type=template&id=5d7b2266"
import script from "./LmSlider.vue?vue&type=script&lang=ts"
export * from "./LmSlider.vue?vue&type=script&lang=ts"
import style0 from "./LmSlider.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default,CompCard: require('/app/components/base/CompCard/CompCard.vue').default})
